import React, { Component, Fragment } from 'react';
import {Header, Footer} from './layouts/'
import './App.css'
import Router from './router'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      currentPage: '',
    };
  }

  render() {
    return (
      <Fragment>
          <Header path={this.props} />
           {/* overflowX for Grid spacing issue: check api */}
            <main style={{overflowX: 'hidden'}}>
              <Router />
            </main>
          <Footer date={this.state.date}/>
        </Fragment>
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/component/App.js